import React from "react";
import { Box } from "@mui/material";

import useStyles from "./styles";

const SeriesLabel = ({ color, label, labelSize = 14 }) => {
  const classes = useStyles();

  return (
    <Box display={"flex"} alignItems={"center"}>
      <span
        style={{
          width: 14,
          height: 14,
          borderRadius: 8,
          backgroundColor: color,
        }}
      />
      <Box ml={3} className={classes.labelText} sx={{ fontSize: labelSize }}>
        {label}
      </Box>
    </Box>
  );
};

export default SeriesLabel;
